import styled from 'styled-components';

export const PerspectivesSection = styled.section`
  padding: 5rem 0;
  background: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url('/back_imgs/clients.png') no-repeat center center;
  background-size: cover;
  background-color: var(--card-background);

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-color);
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

export const AreasContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: var(--background-color);
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  }
`;

export const AreaNumber = styled.span`
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-right: 1.5rem;
  opacity: 0.8;
  min-width: 40px;
`;

export const AreaTitle = styled.h3`
  font-size: 1.3rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-weight: 600;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const AreaDescription = styled.p`
  font-size: 1rem;
  color: var(--text-color);
  line-height: 1.6;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;